import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import api from "../../api";

const ManageItemsWidget = () => {
  const [inventory, setInventory] = useState([]);
  const [storeItems, setStoreItems] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [inventoryRes, storeRes] = await Promise.all([
          api.get("/v1/inventory", { withCredentials: true }),
          api.get("/v1/store", { withCredentials: true })
        ]);
        
        // Filter items with amount > 0
        const filteredInventory = inventoryRes.data.filter(
          (item) => item.amount > 0 || item.stack_amount > 0
        );
        setInventory(filteredInventory);
        
        // Create store items map
        const itemsMap = {};
        storeRes.data.forEach(item => {
          itemsMap[item.id] = item;
        });
        setStoreItems(itemsMap);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching items:", err);
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  // Filter items based on search query
  const filteredInventory = inventory.filter((invItem) => {
    const item = storeItems[invItem.item];
    if (!item) return false;
    if (!searchQuery) return true;
    return item.name.toLowerCase().includes(searchQuery.toLowerCase());
  });

  if (loading) {
    return (
      <div style={{ 
        color: "rgba(255, 255, 255, 0.7)",
        backgroundColor: "rgba(255, 255, 255, 0.05)",
        borderRadius: "8px",
        padding: "1.5rem",
        textAlign: "center",
        border: "1px solid rgba(255, 255, 255, 0.1)"
      }}>
        <img src="/loading.gif" alt="Loading..." width="32" /> Loading items...
      </div>
    );
  }

  // Show top 8 items
  const topItems = filteredInventory.slice(0, 8);

  return (
    <React.Fragment>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h5 style={{ 
          color: "#ffffff", 
          fontWeight: "600",
          margin: 0,
          paddingLeft: "0.5rem",
          borderLeft: "3px solid rgba(251, 146, 60, 0.8)"
        }}>Your Items</h5>
        <a 
          href="/manage-items" 
          style={{ 
            color: "var(--theme-accent)", 
            textDecoration: "none",
            fontSize: "0.9rem",
            fontWeight: "500"
          }}
        >
          Manage All →
        </a>
      </div>

      {/* Search Box */}
      <div style={{ position: 'relative', marginBottom: '1rem' }}>
        <input
          type="text"
          placeholder="Search items..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: '100%',
            padding: '10px 40px 10px 15px',
            borderRadius: '8px',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            color: '#ffffff',
            fontSize: '0.9rem'
          }}
        />
        <div style={{
          position: 'absolute',
          right: '15px',
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'rgba(255, 255, 255, 0.5)',
          pointerEvents: 'none'
        }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="M21 21l-4.35-4.35"></path>
          </svg>
        </div>
      </div>

      <Row>
        {topItems.length > 0 ? (
          topItems.map((invItem) => {
            const item = storeItems[invItem.item];
            if (!item) return null;
            
            return (
              <Col key={invItem.item} md="3" sm="6" className="mb-3">
                <Card
                  style={{
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    border: "none",
                    overflow: "hidden",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    backgroundColor: "#1d222e",
                    cursor: "pointer"
                  }}
                  className="hover-effect"
                >
                  <CardBody className="text-center" style={{
                    backgroundColor: "#242836",
                    padding: "1.25rem",
                    position: "relative"
                  }}>
                    <img
                      src={`/${item.image}`}
                      alt={item.name}
                      style={{ width: "60px", height: "60px", objectFit: "contain" }}
                    />
                    <h6 style={{ 
                      marginTop: "0.75rem",
                      color: "#ffffff",
                      fontWeight: "600",
                      fontSize: "0.85rem"
                    }}>
                      {item.name}
                    </h6>
                    <div style={{
                      position: "absolute",
                      top: "8px",
                      right: "8px",
                      backgroundColor: "rgba(251, 146, 60, 0.9)",
                      color: "#ffffff",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.3)"
                    }}>
                      {invItem.amount || invItem.stack_amount}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            );
          })
        ) : (
          <div style={{ 
            color: "rgba(255, 255, 255, 0.7)",
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            borderRadius: "8px",
            padding: "1.5rem",
            textAlign: "center",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            width: "100%",
            margin: "0 15px"
          }}>
            <i className="ri-inbox-line" style={{ fontSize: "2rem", marginBottom: "0.5rem" }}></i>
            <p>No items in your inventory.</p>
          </div>
        )}
      </Row>
    </React.Fragment>
  );
};

export default ManageItemsWidget;
